import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.65383 10.15L11.4513 14.9474C11.7543 15.2505 12.2457 15.2505 12.5487 14.9474L17.3462 10.15C17.835 9.66113 17.4888 8.82532 16.7975 8.82532L7.20252 8.82532C6.51121 8.82532 6.16501 9.66113 6.65383 10.15Z",
		fill: "currentColor"
	})
});
export default SvgCaretDown;
